import Modules from '@/config/modules'
import Profiles from '@/config/profiles'

const FIND_CONFIG = {
  "staff": {
    tag: "Staff",
    alert: "Seleccionar un STAFF. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "staff/find/control/controlShow",
    urlFilterAPI: "staff/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "staff-subscription-push": {
    tag: "Staff Subscriptos",
    alert: "Seleccionar un STAFF. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "staff/find/control/controlShowSuscriptionPush",
    urlFilterAPI: "staff/find/control/controlByFilterSuscriptionPush",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "customers": {
    tag: "Clientes",
    alert: "Seleccionar un CLIENTE. <b>Buscar por [ID | Código | Nombre | CUIT]</b>",
    list: ['code', 'name'],
    fieldList: ['Código', 'Nombre'],
    urlShowAPI: "customers/find/control/controlShow",
    urlFilterAPI: "customers/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: 'CustomerViewStaff', viewEditParamID: 'customersID',
    permission: { module_id: Modules.CLIENTES, profile_id: Profiles.PERSONAL, view_reference: 'crud' },
  },
  "customers-subscription-push": {
    tag: "Clientes Subscriptos",
    alert: "Seleccionar un CLIENTE. <b>Buscar por [ID | Código | Nombre]</b>",
    list: ['code', 'name'],
    fieldList: ['Código', 'Nombre'],
    urlShowAPI: "customers/find/control/controlShowSuscriptionPush",
    urlFilterAPI: "customers/find/control/controlByFilterSuscriptionPush",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "suppliers": {
    tag: "Proveedores",
    alert: "Seleccionar un PROVEEDOR. <b>Buscar por [ID | Código | Nombre | CUIT]</b>",
    list: ['code', 'name'],
    fieldList: ['Código', 'Nombre'],
    urlShowAPI: "suppliers/find/control/controlShow",
    urlFilterAPI: "suppliers/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: 'SuppliersViewStaff', viewEditParamID: 'suppliersID',
    permission: { module_id: Modules.PROVEEDORES, profile_id: Profiles.PERSONAL, view_reference: 'crud' },
  },
  "suppliers-subscription-push": {
    tag: "Proveedores Subscriptos",
    alert: "Seleccionar un PROVEEDOR. <b>Buscar por [ID | Código | Nombre]</b>",
    list: ['code', 'name'],
    fieldList: ['Código', 'Nombre'],
    urlShowAPI: "suppliers/find/control/controlShowSuscriptionPush",
    urlFilterAPI: "suppliers/find/control/controlByFilterSuscriptionPush",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "tanks": {
    tag: "Tanques",
    alert: "Seleccionar tanque. <b>Buscar por [ID | Código | Nombre]</b>",
    list: ['code', 'name'],
    fieldList: ['Código', 'Nombre'],
    urlShowAPI: "sensors/tanks/find/control/controlShow",
    urlFilterAPI: "sensors/tanks/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "employee": {
    tag: "Empleados",
    alert: "Seleccionar empleados. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "employee/employee/find/control/controlShow",
    urlFilterAPI: "employee/employee/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "employeeCategory": {
    tag: "Categorías",
    alert: "Seleccionar categoría. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "employee/category/find/control/controlShow",
    urlFilterAPI: "employee/category/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.EMPLEADOS, profile_id: Profiles.PERSONAL, view_reference: 'crudEmployee' },
  },
  "project": {
    tag: "Proyectos",
    alert: "Seleccionar proyecto. <b>Buscar por [ID | Nombre]</b>",
    list: ['name', 'customer.name'],
    fieldList: ['Nombre', 'Cliente'],
    urlShowAPI: "projects/projects/find/control/controlShow",
    urlFilterAPI: "projects/projects/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.PROYECTOS, profile_id: Profiles.PERSONAL, view_reference: 'crudProject' },
  },
  "activity": {
    tag: "Actividades",
    alert: "Seleccionar actividad. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "projects/activity/find/control/controlShow",
    urlFilterAPI: "projects/activity/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.PROYECTOS, profile_id: Profiles.PERSONAL, view_reference: 'crudActivity' },
  },
  "products": {
    tag: "Productos",
    alert: "Seleccionar productos. <b>Buscar por [ID | Código | Nombre | Código de Barra]</b>",
    list: ['code', 'name'],
    fieldList: ['Código', 'Nombre'],
    urlShowAPI: "products/find/control/controlShow",
    urlFilterAPI: "products/find/control/controlByFilter",
    searchResultLength: 2,
    autoFilterEnabled: false,
    enabledAllRegister: false,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    init(ctx) {
      if (ctx.parameters.origenProducts) {
        ctx.control.list = ['code', 'supplier_name', 'name']
        ctx.control.fieldList = ['Código', 'Proveedor', 'Nombre']
      }
    },
  },
  "productsLine": {
    tag: "Lineas",
    alert: "Seleccionar lineas. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "products-line/find/control/controlShow",
    urlFilterAPI: "products-line/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.PRODUCTOS, profile_id: Profiles.PERSONAL, view_reference: 'crudItems' },
  },
  "productsCategory": {
    tag: "Categorias",
    alert: "Seleccionar categorías. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "products-category/find/control/controlShow",
    urlFilterAPI: "products-category/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.PRODUCTOS, profile_id: Profiles.PERSONAL, view_reference: 'crudCategories' },
  },
  "productsSubCategory": {
    tag: "Categorías",
    alert: "Seleccionar sub-categorías. <b>Buscar por [ID | Nombre]</b>",
    list: ['category.name', 'name'],
    fieldList: ['Categoría', 'Subcategoría'],
    urlShowAPI: "products-subcategory/find/control/controlShow",
    urlFilterAPI: "products-subcategory/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.PRODUCTOS, profile_id: Profiles.PERSONAL, view_reference: 'crudCategories' },
  },
  "productsSubCategoryParent": {
    tag: "Categorías",
    alert: "Seleccionar sub-categorías. <b>Buscar por [ID | Nombre]</b>",
    list: ['category.name', 'name'],
    fieldList: ['Categoría', 'Subcategoría'],
    urlShowAPI: "products-subcategory/find/control/controlShowParent",
    urlFilterAPI: "products-subcategory/find/control/controlByFilterParent",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "productsSubLine": {
    tag: "Lineas",
    alert: "Seleccionar sub-lineas. <b>Buscar por [ID | Nombre]</b>",
    list: ['line.name', 'name'],
    fieldList: ['Linea', 'Sublinea'],
    urlShowAPI: "products-subline/find/control/controlShow",
    urlFilterAPI: "products-subline/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.PRODUCTOS, profile_id: Profiles.PERSONAL, view_reference: 'crudItems' },
  },
  "productsColors": {
    tag: "Colores",
    alert: "Seleccionar colores. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "products-colors/find/control/controlShow",
    urlFilterAPI: "products-colors/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.PRODUCTOS, profile_id: Profiles.PERSONAL, view_reference: 'crudColors' },
  },
  "productsWaist": {
    tag: "Talles",
    alert: "Seleccionar talles. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "products-waist/find/control/controlShow",
    urlFilterAPI: "products-waist/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.PRODUCTOS, profile_id: Profiles.PERSONAL, view_reference: 'crudWaist' },
  },
  "sellers": {
    tag: "Vendedores",
    alert: "Seleccionar vendedor. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "sellers/find/control/controlShow",
    urlFilterAPI: "sellers/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "sellersZone": {
    tag: "Zonas",
    alert: "Seleccionar zona. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "sellers-zone/find/control/controlShow",
    urlFilterAPI: "sellers-zone/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "currency": {
    tag: "Moneda",
    alert: "Seleccionar moneda. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "price-currency/find/control/controlShow",
    urlFilterAPI: "price-currency/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.PRECIOS, profile_id: Profiles.PERSONAL, view_reference: 'crudCurrency' },
  },
  "contentsBlock": {
    tag: "Bloque",
    alert: "Seleccionar bloque. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "contents-block/find/control/controlShow",
    urlFilterAPI: "contents-block/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "courses": {
    tag: "Cursos",
    alert: "Seleccionar cursos. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "courses/find/control/controlShow",
    urlFilterAPI: "courses/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "coursesCategory": {
    tag: "Categorias",
    alert: "Seleccionar categorías. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "courses-category/find/control/controlShow",
    urlFilterAPI: "courses-category/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "coursesSubCategory": {
    tag: "Categorías",
    alert: "Seleccionar sub-categorías. <b>Buscar por [ID | Nombre]</b>",
    list: ['category.name', 'name'],
    fieldList: ['Categoría', 'Subcategoría'],
    urlShowAPI: "courses-subcategory/find/control/controlShow",
    urlFilterAPI: "courses-subcategory/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "servicesCategory": {
    tag: "Categorias",
    alert: "Seleccionar categorías. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "services-category/find/control/controlShow",
    urlFilterAPI: "services-category/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.SERVICIOS, profile_id: Profiles.PERSONAL, view_reference: 'crudCategory' },
  },
  "services": {
    tag: "Servicios",
    alert: "Seleccionar servicios. <b>Buscar por [ID | Categoría | Nombre]</b>",
    list: ['category.name', 'name'],
    fieldList: ['Categoría', 'Nombre'],
    urlShowAPI: "services/find/control/controlShow",
    urlFilterAPI: "services/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "servicesCustomers": {
    tag: "Servicios de Cliente",
    alert: "Seleccionar servicios. <b>Buscar por [Referencia | Servicio]</b>",
    list: ['service_customer.name', 'service.name'],
    fieldList: ['Referencia', 'Servicio'],
    urlShowAPI: "services-customers-details/find/control/controlShow",
    urlFilterAPI: "services-customers-details/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "reports": {
    tag: "Reportes",
    alert: "Seleccionar reportes. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "reports/find/control/controlShow",
    urlFilterAPI: "reports/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "priceList": {
    tag: "Lista de Precios",
    alert: "Seleccionar lista de precios. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "price-list/find/control/controlShow",
    urlFilterAPI: "price-list/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "erpPointsSales": {
    allRegister: true,
    tag: "Punto de Venta",
    alert: "Seleccionar puntos de ventas. <b>Buscar por [ID | Punto de Venta | Nombre]</b>",
    list: ['business.name', 'point_sale', 'name'],
    fieldList: ['Empresa', 'Punto de Venta', 'Nombre'],
    urlShowAPI: "sales-points-sales/find/control/controlShow",
    urlFilterAPI: "sales-points-sales/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "erpMethodsPayment": {
    tag: "Métodos de Pago",
    alert: "Seleccionar métodos de pago. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "sales-methods-payment/find/control/controlShow",
    urlFilterAPI: "sales-methods-payment/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.VENTAS, profile_id: Profiles.PERSONAL, view_reference: 'settings' },
  },
  "erpFiscalConditions": {
    tag: "Condiciones Fiscales",
    alert: "Seleccionar condición fiscal. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "sales-fiscal-conditions/find/control/controlShow",
    urlFilterAPI: "sales-fiscal-conditions/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "erpIvaConditions": {
    tag: "Condiciones de IVA",
    alert: "Seleccionar condición de IVA. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "sales-iva-conditions/find/control/controlShow",
    urlFilterAPI: "sales-iva-conditions/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "erpTypeDocuments": {
    tag: "Tipos de Documentos",
    alert: "Seleccionar tipo de documento. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "sales-types-documents/find/control/controlShow",
    urlFilterAPI: "sales-types-documents/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "accountingAccounts": {
    tag: "Cuentas Contables",
    alert: "Seleccionar la cuenta contable. <b>Buscar por [Código | Nombre]</b>",
    list: ['code', 'name', 'parent.name', 'type'],
    fieldList: ['Código', 'Nombre', 'Grupo', 'Tipo'],
    urlShowAPI: "accounting-accounts/find/control/controlShow",
    urlFilterAPI: "accounting-accounts/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "accountingAccountsNotImputation": {
    tag: "Cuentas Contables",
    alert: "Seleccionar la cuenta contable. <b>Buscar por [Código | Nombre]</b>",
    list: ['code', 'name', 'parent.name', 'type'],
    fieldList: ['Código', 'Nombre', 'Grupo', 'Tipo'],
    urlShowAPI: "accounting-accounts/find/control/controlShowNotImputation",
    urlFilterAPI: "accounting-accounts/find/control/controlByFilterNotImputation",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "accountingAccountsImputation": {
    tag: "Cuentas Contables",
    alert: "Seleccionar la cuenta contable. <b>Buscar por [Código | Nombre]</b>",
    list: ['code', 'name', 'parent.name', 'type'],
    fieldList: ['Código', 'Nombre', 'Grupo', 'Tipo'],
    urlShowAPI: "accounting-accounts/find/control/controlShowImputation",
    urlFilterAPI: "accounting-accounts/find/control/controlByFilterImputation",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "whatsappMarketingList": {
    tag: "Lista de Contactos",
    alert: "Seleccionar lista de contactos. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "whatsapp-marketing-list/find/control/controlShow",
    urlFilterAPI: "whatsapp-marketing-list/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "cash": {
    tag: "Caja/Cuenta",
    alert: "Seleccionar caja/cuenta. <b>Buscar por [ID | Nombre]</b>",
    list: ['name', 'type'],
    fieldList: ['Nombre', 'Tipo'],
    urlShowAPI: "finances-cash/find/control/controlShow",
    urlFilterAPI: "finances-cash/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "concepts": {
    tag: "Conceptos",
    alert: "Seleccionar conceptos. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "sales-concepts/find/control/controlShow",
    urlFilterAPI: "sales-concepts/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.VENTAS, profile_id: Profiles.PERSONAL, view_reference: 'settings' },
  },
  "productsCompound": {
    tag: "Productos Compuestos",
    alert: "Seleccionar productos compuestos. <b>Buscar por [ID | Código | Nombre]</b>",
    list: ['code', 'name'],
    fieldList: ['Código', 'Nombre'],
    urlShowAPI: "products-compound/find/control/controlShow",
    urlFilterAPI: "products-compound/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "unitMeasurement": {
    tag: "Unidades de Medidas",
    alert: "Seleccionar unidades de medidas. <b>Buscar por [ID | Nombre]</b>",
    list: ['reference', 'name'],
    fieldList: ['Referencia', 'Nombre'],
    urlShowAPI: "products-unit-measurement/find/control/controlShow",
    urlFilterAPI: "products-unit-measurement/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "deposits": {
    tag: "Depósitos",
    alert: "Seleccionar depósitos. <b>Buscar por [Referencia | Nombre]</b>",
    list: ['reference', 'name'],
    fieldList: ['Depósito', 'Nombre'],
    urlShowAPI: "deposits/find/control/controlShow",
    urlFilterAPI: "deposits/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "deposits-zone": {
    tag: "Zona de Depósitos",
    alert: "Seleccionar zonas de depósitos. <b>Buscar por [Referencia | Nombre]</b>",
    list: ['deposit.reference', 'reference', 'name'],
    fieldList: ['Depósito', 'Zona', 'Nombre'],
    urlShowAPI: "deposits-zone/find/control/controlShow",
    urlFilterAPI: "deposits-zone/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "deposits-location": {
    tag: "Ubicación en Zonas de Depósitos",
    alert: "Dos formas para buscar una ubicación:<br><br><b>Genérica:</b> Seleccionar una ubicación de depósitos. <b>Buscar por [Referencia | Nombre]</b> <br><br> <b>Avanzado:</b> D:<i>ref</i>,Z:<i>ref</i>,U:<i>ref</i> (Puede omitir parametros pudiendo filtrar solo por depósito, zona y/o ubicación)",
    list: ['zone.deposit.reference', 'zone.reference', 'reference', 'name'],
    fieldList: ['Depósito', 'Zona', 'Ubicación', 'Nombre'],
    urlShowAPI: "deposits-locations/find/control/controlShow",
    urlFilterAPI: "deposits-locations/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "instances-server": {
    tag: "Servidores (VPS)",
    alert: "Seleccionar un servidor. <b>Buscar por [Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "instances-server/find/control/controlShow",
    urlFilterAPI: "instances-server/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "instances-categories": {
    tag: "Agrupación de Instancias",
    alert: "Seleccionar una agrupación. <b>Buscar por [Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "instances-categories/find/control/controlShow",
    urlFilterAPI: "instances-categories/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "erpMethodsAcopio": {
    tag: "Métodos de Acopio",
    alert: "Seleccionar métodos de acopio. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "sales-methods-acopio/find/control/controlShow",
    urlFilterAPI: "sales-methods-acopio/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.VENTAS, profile_id: Profiles.PERSONAL, view_reference: 'settings' },
  },
  "orders-reason": {
    tag: "Motivos",
    alert: "Seleccionar un motivo. <b>Buscar por [Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "orders-reason/find/control/controlShow",
    urlFilterAPI: "orders-reason/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "my-business": {
    tag: "Empresas",
    alert: "Seleccionar una empresa. <b>Buscar por [Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "accounting-business/find/control/controlShow",
    urlFilterAPI: "accounting-business/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "costsSuppliersProductsSupport": {
    tag: "Productos Externos",
    alert: "Seleccionar productos externos. <b>Buscar por [Referencia | Proveedor | Producto]</b>",
    list: ['reference', 'suppliers', 'description', 'price'],
    fieldList: ['Referencia Externa', 'Proveedor', 'Producto', 'Precio'],
    urlShowAPI: "costs/suppliers-products-update-external-support/find/control/controlShow",
    urlFilterAPI: "costs/suppliers-products-update-external-support/find/control/controlByFilter",
    searchResultLength: 3,
    autoFilterEnabled: false,
    enabledAllRegister: false,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "purchaseCategory": {
    tag: "Categoría de Compra",
    alert: "Seleccionar categorías de compra. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "purchase-category/find/control/controlShow",
    urlFilterAPI: "purchase-category/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.COMPRAS, profile_id: Profiles.PERSONAL, view_reference: 'purchaseCategory' },
  },
  "modules": {
    tag: "Módulos",
    alert: "Seleccionar módulos. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "modules/find/control/controlShow",
    urlFilterAPI: "modules/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
  },
  "purchaseInfoPayment": {
    tag: "Formas de Pago",
    alert: "Seleccionar formas de pago para la compra. <b>Buscar por [ID | Nombre]</b>",
    list: ['name'],
    fieldList: ['Nombre'],
    urlShowAPI: "purchase-infoPayment/find/control/controlShow",
    urlFilterAPI: "purchase-infoPayment/find/control/controlByFilter",
    searchResultLength: 0,
    autoFilterEnabled: false,
    enabledAllRegister: true,
    viewAdd: '', viewEdit: '', viewEditParamID: '',
    permission: { module_id: Modules.COMPRAS, profile_id: Profiles.PERSONAL, view_reference: 'infoPayment' },
  },
}

export default FIND_CONFIG
